const userManage = {
  state: {
    userInfo: {},
  },

  mutations: {
    SET_USERINFO(state, userInfo) {
      state.userInfo = Object.assign({}, userInfo)
    },
  },
}

export default userManage
